
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.775","height":"13.687"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 14300","opacity":".87","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.4"}},[_c('path',{attrs:{"data-name":"Path 3455","d":"M6.42.7H.7v12.287h5.72"}}),_c('path',{attrs:{"data-name":"Path 3456","d":"M5.485 6.82h8.3l-3.1 3.24"}}),_c('path',{attrs:{"data-name":"Line 1680","d":"M13.785 6.82l-3.097-3.193"}})])])
          )
        }
      }
    